import { Box } from "@mui/material";

export const OperatorBox = ({ children }) => (
  <Box
    sx={{
      width: { xs: "2rem", sm: "2.375rem" },
      height: { xs: "2rem", sm: "2.375rem" },
      borderRadius: "50%",
      paddingBottom: "3px",
      backgroundColor: "grey.100",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "700",
      fontSize: "1.5rem",
      alignSelf: "center",
      color: "text.secondary",
      flexShrink: 0,
    }}
  >
    {children}
  </Box>
);
